export default __webpack_public_path__ + "i18n/translations/translation-ko.670d7828.json";